import * as React from 'react'
import * as fs from './footer.module.scss'
import qrcodeDownload from '@images/qrcode-download-app.png'
import wxPublish from '@images/wxPublish.png'
import weiboCode from '@images/weiboCode.png'
import miniProgramCode from '@images/miniProgramCode.png'
import Logo from '@images/logo_white.png'
import Foot2 from '@images/footer_1.png'
import { Link } from 'gatsby'

const Footer = () => {
  return (
    <footer className={fs.footer}>
      <div className={fs.footerTop}>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={qrcodeDownload} alt="别样APP下载二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <div>下载别样APP</div>
            <span>领</span>
            <span className={fs.footerTopQrcodeTextHighlight}>688元</span>
            <span>新人大礼包</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={wxPublish} alt="别样官方微信二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>官方微信</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={weiboCode} alt="别样官方微博二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>官方微博</span>
          </div>
        </div>
        <div className={fs.footerTopQrcode}>
          <div className={fs.footerTopQrcodeBox}>
            <img className={fs.footerTopQrcodeBoxImg} src={miniProgramCode} alt="别样小程序二维码" />
          </div>
          <div className={fs.footerTopQrcodeText}>
            <span>别样小程序</span>
          </div>
        </div>
        <div className={fs.footerTopRight}>
          <img className={fs.footerTopRightLogo} src={Logo} alt="底部-logo" />
          <div className={fs.footerTopRightDescription}>下载别样APP，领 <span>688元</span> 新人大礼包</div>
          <div className={fs.footerTopRightAddress}>别样海外总部：298 S Sunnyvale Ave, STE 210 Sunnyvale, CA 94086</div>
          <Link href='/bieyang/growth/'><div className={fs.footerTopRightAddress}>别样中国总部：上海市浦东新区张江高科科苑路399号10号楼12层</div></Link>
        </div>
      </div>
      <div className={fs.footerBottom}>
        Copyright © 2015-2022, 上海别样秀数据科技有限公司, 上海市浦东新区张江高科科苑路399号10号楼12层, 021-61514616, All rights reserved. <a target='_blank' href="https://beian.miit.gov.cn/#/Integrated/recordQuery">沪ICP备 18004034号</a>|
          <a target='_blank' href="https://baleen-cdn-g.bieyangapp.com/by/info/icpediwatermark.pdf">增值电信业务经营许可证：沪B2-20190462</a> <a target='_blank' href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020190319171346000004469222-SAIC_SHOW_310000-4028e4cb69e32371016a44ea858c3934228&signData=MEYCIQDHbTLsJBMSvGqSpEhaa8UbCIMHuGAKsE6890TxMhoI9gIhANnjtCP9obDgUPyROL8e4lYUTfTIT1cDh5NLBl7k2MOl"><img src={Foot2} alt="" /></a>
      </div>
    </footer>
  )
}

export default Footer